export default __webpack_public_path__ + "static/media/sticker-m.3815254a.png";